import e, { Component as r } from "react";
import { HeaderCell as o } from "./HeaderCell.js";
function t(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function n(e, r) {
  for (var o = 0; o < r.length; o++) {
    var t = r[o];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
  }
}
function l(e, r, o) {
  return r in e ? Object.defineProperty(e, r, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = o, e;
}
function s(e) {
  return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function a(e, r) {
  return (a = Object.setPrototypeOf || function (e, r) {
    return e.__proto__ = r, e;
  })(e, r);
}
var i = function (r) {
  !function (e, r) {
    if ("function" != typeof r && null !== r) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(r && r.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), r && a(e, r);
  }(d, r);
  var i,
    p,
    u,
    c = (i = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        r,
        o = s(d);
      if (i) {
        var n = s(this).constructor;
        r = Reflect.construct(o, arguments, n);
      } else r = o.apply(this, arguments);
      return (e = r) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : t(this);
    });
  function d() {
    var e;
    return !function (e, r) {
      if (!(e instanceof r)) throw TypeError("Cannot call a class as a function");
    }(this, d), e = c.apply(this, arguments), l(t(e), "state", {
      sortableDisabledFields: [],
      allSortableDisabled: !1,
      styleObject: {}
    }), l(t(e), "onSortableChange", function () {
      e.updateSortableDisabled();
    }), l(t(e), "onCheckboxChange", function (r) {
      e.props.onColumnCheckboxChange(r, e.props.value);
    }), e;
  }
  return p = [{
    key: "isSingleSort",
    value: function value() {
      return "single" === this.props.sortMode;
    }
  }, {
    key: "isMultipleSort",
    value: function value() {
      return "multiple" === this.props.sortMode;
    }
  }, {
    key: "isAllSortableDisabled",
    value: function value() {
      return this.isSingleSort() && this.state.allSortableDisabled;
    }
  }, {
    key: "isColumnSorted",
    value: function value(e) {
      return null !== this.props.sortField && (e.props.field === this.props.sortField || e.props.sortField === this.props.sortField);
    }
  }, {
    key: "updateSortableDisabled",
    value: function value() {
      var e = this;
      if (this.isSingleSort() || this.isMultipleSort() && this.props.onSortChange) {
        var r = [],
          o = !1;
        this.props.columns.forEach(function (t) {
          t.props.sortableDisabled && (r.push(t.props.sortField || t.props.field), !o && e.isColumnSorted(t) && (o = !0));
        }), this.setState({
          sortableDisabledFields: r,
          allSortableDisabled: o
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.updateSortableDisabled();
    }
  }, {
    key: "renderGroupHeaderCells",
    value: function value(r) {
      var o = e.Children.toArray(r.props.children);
      return this.renderHeaderCells(o);
    }
  }, {
    key: "renderHeaderCells",
    value: function value(r) {
      var t = this;
      return e.Children.map(r, function (r, n) {
        var l = !r || !r.props.hidden,
          s = r && (r.props.columnKey || r.props.field) || n;
        return l && e.createElement(o, {
          key: s,
          value: t.props.value,
          tableProps: t.props.tableProps,
          column: r,
          tabIndex: t.props.tabIndex,
          tableSelector: t.props.tableSelector,
          empty: t.props.empty,
          resizableColumns: t.props.resizableColumns,
          groupRowsBy: t.props.groupRowsBy,
          groupRowSortField: t.props.groupRowSortField,
          sortMode: t.props.sortMode,
          sortField: t.props.sortField,
          sortOrder: t.props.sortOrder,
          multiSortMeta: t.props.multiSortMeta,
          allSortableDisabled: t.isAllSortableDisabled(),
          onSortableChange: t.onSortableChange,
          sortableDisabledFields: t.state.sortableDisabledFields,
          onColumnMouseDown: t.props.onColumnMouseDown,
          onColumnDragStart: t.props.onColumnDragStart,
          onColumnDragOver: t.props.onColumnDragOver,
          onColumnDragLeave: t.props.onColumnDragLeave,
          onColumnDrop: t.props.onColumnDrop,
          onColumnResizeStart: t.props.onColumnResizeStart,
          onColumnResizerClick: t.props.onColumnResizerClick,
          onColumnResizerDoubleClick: t.props.onColumnResizerDoubleClick,
          allRowsSelected: t.props.allRowsSelected,
          onColumnCheckboxChange: t.onCheckboxChange,
          reorderableColumns: t.props.reorderableColumns,
          onSortChange: t.props.onSortChange
        });
      });
    }
  }, {
    key: "renderContent",
    value: function value() {
      var r = this,
        o = "datatable__row datatable__row--head";
      if (this.props.headerColumnGroup) return e.Children.toArray(this.props.headerColumnGroup.props.children).map(function (t, n) {
        return e.createElement("tr", {
          key: n,
          className: o,
          role: "row"
        }, r.renderGroupHeaderCells(t));
      });
      var t = e.createElement("tr", {
        className: o,
        role: "row"
      }, this.renderHeaderCells(this.props.columns));
      return e.createElement(e.Fragment, null, t);
    }
  }, {
    key: "render",
    value: function value() {
      var r = this.renderContent();
      return e.createElement("thead", {
        ref: this.props.wrapperRef,
        className: "datatable__head"
      }, r);
    }
  }], n(d.prototype, p), u && n(d, u), d;
}(r);
export { i as TableHeader };